/* =============================================
   BROKN — Guide des tailles drawer (Filtre intelligent)
   ============================================= */

(function() {
  // Gestion globale de l'ouverture au clic sur un trigger
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.brokn-size-guide-trigger');
    if (!trigger) return;

    const drawer = document.querySelector('.brokn-size-guide-drawer');
    const overlay = document.querySelector('.brokn-size-guide-overlay');
    const content = document.getElementById('brokn-size-guide-content');
    
    if (!drawer || !content) return;

    // 1. Récupération du contexte de l'option parent
    const container = trigger.closest('.brokn-size-container');
    const optionLabel = container ? container.dataset.optionLabel.toLowerCase() : 'tailles';

    // 2. Récupération de toutes les lignes du guide des tailles
    const allRows = JSON.parse(trigger.dataset.guide || '[]');
    if (!allRows.length) {
      content.innerHTML = '<p>Aucun guide des tailles disponible.</p>';
      openDrawer();
      return;
    }

    // 3. Condition d'affichage : On filtre le JSON selon le libellé de la variante
    let filteredRows = [];
    let activeType = '';

    if (optionLabel.includes('haut')) {
      // Si le libellé contient "haut", on ne garde que les hauts
      filteredRows = allRows.filter(row => row.type === 'haut' || row.type === 'hauts');
      activeType = 'haut';
    } else if (optionLabel.includes('bas')) {
      // Si le libellé contient "bas", on ne garde que les bas
      filteredRows = allRows.filter(row => row.type === 'bas');
      activeType = 'bas';
    } else {
      // Produit classique (libellé "tailles") : on prend tout et on se base sur le type de la 1ère ligne
      filteredRows = allRows;
      activeType = allRows[0] ? allRows[0].type : 'haut';
    }

    // Sécurité si le filtre n'a rien trouvé
    if (!filteredRows.length) filteredRows = allRows;

    // 4. Construction du tableau HTML correspondant
    function buildTable() {
      let html = '<table class="brokn-size-guide-table"><thead><tr>';

      if (activeType === 'bas') {
        html += '<th>Taille</th><th>Tour de hanches*</th><th>FR</th><th>US</th>';
      } else {
        html += '<th>Taille</th><th>Tour de poitrine*</th><th>Tour de taille*</th><th>Longueur*</th><th>FR</th>';
      }

      html += '</tr></thead><tbody>';

      filteredRows.forEach(row => {
        if (activeType === 'bas') {
          html += `<tr>
            <td>${row.taille || ''}</td>
            <td>${row.tour_de_hanches || ''}</td>
            <td>${row.fr || ''}</td>
            <td>${row.us || ''}</td>
          </tr>`;
        } else {
          html += `<tr>
            <td>${row.taille || ''}</td>
            <td>${row.tour_de_poitrine || ''}</td>
            <td>${row.tour_de_taille || ''}</td>
            <td>${row.longueur || ''}</td>
            <td>${row.fr || ''}</td>
          </tr>`;
        }
      });

      html += '</tbody></table>';
      html += '<p class="brokn-size-guide-note">* Mesures en cm</p>';
      return html;
    }

    // Fonctions d'ouverture internes
    function openDrawer() {
      drawer.classList.add('is-open');
      if (overlay) overlay.style.display = 'block';
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    // Injection et affichage
    content.innerHTML = buildTable();
    openDrawer();
  });

  // Gestion globale de la fermeture (clic à l'extérieur ou bouton croix)
  document.addEventListener('click', function(e) {
    const drawer = document.querySelector('.brokn-size-guide-drawer');
    const overlay = document.querySelector('.brokn-size-guide-overlay');
    
    if (!drawer) return;

    if (e.target.closest('.brokn-size-guide-drawer__close') || e.target === overlay) {
      closeDrawer(drawer, overlay);
    }
  });

  // Gestion de la touche Échap
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const drawer = document.querySelector('.brokn-size-guide-drawer');
      const overlay = document.querySelector('.brokn-size-guide-overlay');
      if (drawer && drawer.classList.contains('is-open')) {
        closeDrawer(drawer, overlay);
      }
    }
  });

  function closeDrawer(drawer, overlay) {
    drawer.classList.remove('is-open');
    if (overlay) overlay.style.display = 'none';
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
})();